<div class="snack">
	<div class="snack__image-info">
		<mat-icon svgIcon="sanus-{{ data.type }}"></mat-icon>
		<span>{{ getInfoMessage(data.type, data.info) }}</span>
	</div>
	<button class="snack__btn-close" (click)="closeSnack()">
		<mat-icon svgIcon="sanus-close"></mat-icon>
	</button>
</div>
